module.exports = __webpack_public_path__ + "static/media/calendar.afce1a7e.svg";